export default "__VITE_ASSET__0447445c__"